import img1 from '../images/killa/killa2.png'; // Make sure these images exist or I will use a different one
import img2 from '../images/amaru/amaru2.png';
import img3 from '../images/aliwen/aliwen1.png';
import img4 from '../images/inti/inti.png';
import img5 from '../images/pacha/pacha.png';
import img6 from '../images/sami/sami.png';
import img7 from '../images/nina/nina1.png';
import img8 from '../images/chaski/chaski.png';
import img9 from '../images/shangu/shangu1.png';
import img10 from '../images/wayiki/wayiki1.png';
import img11 from '../images/wayta/wayta1.png';

const dataBestRooms = [
    {
        id: 1,
        title: 'Habitación Killa',
        desc: 'Habitación privada para 2 personas con cama matrimonial, aire acondicionado. Ideal para parejas que buscan confort.',
        img: img1,
        link: '/killa'
    },
    {
        id: 2,
        title: 'Habitación Amaru',
        desc: 'Dormitorio privado de 2 camas. Incluye lockers grandes, aire acondicionado y cortinas blackout.',
        img: img2,
        link: '/amaru'
    },
    {
        id: 3,
        title: 'Habitación Aliwen',
        desc: 'Habitación compartida mixta de 10 camas individuales, Excelente ambiente amigable y espacioso, pensado para viajeros que buscan socializar.',
        img: img3,
        link: '/aliwen'
    },
    {
        id: 4,
        title: 'Habitación Inti',
        desc: 'Dormitorio para 3 personas, destaca por su gran ventanal de luz natural, con vista a la ciudad.',
        img: img4,
        link: '/inti'
    },
    {
        id: 5,
        title: 'Habitación Pacha',
        desc: ' Cuadruple privada con cama matrimonial y 1 litera,con aire y un ambiente relajante para desconectar por completo.',
        img: img5,
        link: '/pacha'
    },
    {
        id: 6,
        title: 'Habitación Sami',
        desc: ' Compartida femenina para 6 personas. Camas muy cómodas con lockers y amplio baño con vestuarios de mujeres.',
        img: img6,
        link: '/sami'
    },
    {
        id: 7,
        title: 'Habitación Nina',
        desc: 'Habitación privada matrimonial económica con baño compartido. Ideal para descansar cómodamente. ',
        img: img7,
        link: '/nina'
    },
    {
        id: 8,
        title: 'Habitación Chaski',
        desc: 'Habitacion cuadruple privada luminosa. Acceso rapido a la super terraza y áreas comunes.',
        img: img8,
        link: '/chaski'
    },
    {
        id: 9,
        title: 'Habitación Shangu',
        desc: 'Nuestra opción más premium. Suite amplia con cama queen, baño privado, (1 cama matrimonial y 2 literas), aire acondicionado. Un ambiente cálido ideal para familias o grupos de amigos.',
        img: img9,
        link: '/shangu'
    },
    {
        id: 10,
        title: 'Habitación Wayiki',
        desc: 'Habitacion doble basica, con acceso rapido a la terraza y baños compartidos. ',
        img: img10,
        link: '/wayiki'
    },
    {
        id: 11,
        title: 'Habitación Wayta',
        desc: 'Habitación doble superior inspirada en la naturaleza. , baño privado y hermosas comodidades.',
        img: img11,
        link: '/wayta'
    }
]

export default dataBestRooms;
